import React from "react";
import {useState, useEffect} from "react";
import styles from "./ListTab.module.css";
import {
  Button,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  TableCell,
  Checkbox,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
} from "@mui/material";
import ViewImagePopup from "../CommonPopups/ViewImagePopup";
import editIcon from '../../assets/images/edit-icon.svg';
import { CountryCode, isValidPhoneNumber } from "libphonenumber-js";
import FieldFileDropZone from '../FileDropZone/FieldFileDropZone';
import SaveBtn from "../Buttons/SaveBtn";
import CancelBtn from "../Buttons/CancelBtn";
import { useDispatch, useSelector } from "react-redux";
import { updateLeadAdditionalDetails } from "../../pages/app/Nurture/service/nurtureSlice";
import CountryCodePhoneInput from "../CountryCodePhoneInput/CountryCodePhoneInput";
import { useAuthUser } from "react-auth-kit";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { setToastNotification } from "../ToastNotification/service/toastNotificationSlice";
import DeleteBtn from "../Buttons/DeleteBtn";
import dayjs from "dayjs";
import { getLeadAdditionalDetails } from "../../pages/app/Nurture/service/nurtureSlice";

const CustomTableHeaderCell = styled(TableCell)(({ theme }) => ({
  padding: "16px 12px",
  fontSize: "14px",
  color: "#142C44",
  background: "#f7f7fb",
  textTransform: "capitalize",
  fontWeight: "400",
}));
const CustomTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: "13px",
  fontWeight: "400",
  color: "#142C44",
}));

function LeadAdditionalInfoTab(props: any) {
  const { leadAdditionalDetails } = props;
  const capitalizeFirstLetter = (text: any) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
  };

  const formatValue = (text: any) => {
    if (!text) return "";
    const formattedText = text.replace(/_/g, " ");
    return formattedText.charAt(0).toUpperCase() + formattedText.slice(1);
  };

  const[editTrue, setEditTrue] = React.useState(false);

  const {
    updateLeadAdditionalDetailsLoading,
    updateLeadAdditionalDetailsSuccess,
    updateLeadAdditionalDetailsError
  } = useSelector((state: any) => state.nurture);

  const [additionalInfoArray, setAdditionalInfoArray] = React.useState<any>([]);
  const [editedAdditionalInfo, setEditedAdditionalInfo] = React.useState<any[]>([]);
  const [uploadedImages, setUploadedImages] = useState<Record<string, boolean>>({});
  const [resetImageTrigger, setResetImageTrigger] = React.useState<Record<string, number>>({});
  const [validStateContact, setValidStateContact] = React.useState<boolean>(true);
  const [phone, setPhone] = useState<string>("");
  const [contactCountryCode, setContactCountryCode] = useState<string>("91");
  const dispatch = useDispatch();

  useEffect(() => {
    if (!editTrue && leadAdditionalDetails?.additionalInfo) {
      setAdditionalInfoArray([...leadAdditionalDetails.additionalInfo]);
      setEditedAdditionalInfo([...leadAdditionalDetails.additionalInfo]);
    }
  }, [leadAdditionalDetails, editTrue]);
  
  const handleImageUpload = (fieldLabel: string, location: string): void => {

    const updated = editedAdditionalInfo.map((item: any) =>
      item.fieldLabel === fieldLabel &&
      (item.fieldType === "image" || item.fieldType === "profilePic")
        ? { ...item, fieldValue: location }
        : item
    );

    setEditedAdditionalInfo(updated);

    setUploadedImages((prev) => ({
      ...prev,
      [fieldLabel]: true
    }));
  };

  const handledeleteimage = (fieldLabel: string) => {
    const updated = editedAdditionalInfo.map((item: any) =>
      item.fieldLabel === fieldLabel
        ? { ...item, fieldValue: "" }
        : item
    );

    setEditedAdditionalInfo(updated);

    setUploadedImages((prev) => ({
      ...prev,
      [fieldLabel]: false
    }));

    setResetImageTrigger((prev) => ({
      ...prev,
      [fieldLabel]: (prev[fieldLabel] || 0) + 1
    }));
    dispatch(
      setToastNotification({
        message: "Image removed.",
        type: "success",
        snackOpen: true,
      })
    );
  };

  function handleChange(e: any, value: any) {
    const updatedInfo = editedAdditionalInfo.map((item: any) => {
      if (item.fieldLabel === value) {

        if (
          item.fieldType === "select" ||
          item.fieldType === "text" ||
          item.fieldType === "radio"
        ) {
          return { ...item, fieldValue: e.target.value };
        }

        if (item.fieldType === "checkbox") {
          const { checked, value } = e.target;

          let updatedValues = Array.isArray(item.fieldValue)
            ? [...item.fieldValue]
            : [];

          if (checked) {
            if (!updatedValues.includes(value)) {
              updatedValues.push(value);
            }
          } else {
            updatedValues = updatedValues.filter(
              (val: any) => val !== value
            );
          }

          return { ...item, fieldValue: updatedValues };
        }
      }
      return item;
    });

    setEditedAdditionalInfo(updatedInfo);
  }

  const auth = useAuthUser();
  const authUser = auth();

  const handleSave = async () => {
    try {
      // const filteredAdditionalInfo = editedAdditionalInfo.filter((item: any) => {
      //   if (
      //     (item.fieldType === "image" || item.fieldType === "profilePic") &&
      //     !item.fieldValue
      //   ) {
      //     return false;
      //   }
      //   return true;
      // });

      await dispatch<any>(
        updateLeadAdditionalDetails({
          enquiryId: leadAdditionalDetails?.enquiryId,
          instituteId: leadAdditionalDetails?.instituteId,
          createdById: leadAdditionalDetails?.createdById,
          createdByName: leadAdditionalDetails?.createdByName,
          updatedById: authUser?.userId,
          updatedByName: authUser?.firstName + ' ' + authUser?.lastName,
          additionalInfo: editedAdditionalInfo,
        })
      );

      dispatch<any>(
        getLeadAdditionalDetails({
          leadId: leadAdditionalDetails?.enquiryId,
          id: leadAdditionalDetails?.instituteId,
        })
      );

      setEditTrue(false);
    } catch (error) {
      console.error("Update failed:", error);
      dispatch(
        setToastNotification({
          message: "Update failed",
          type: "error",
          snackOpen: true
        }));
    }
  };

  const handleCancel = async () => {
    setEditTrue(false);
    setEditedAdditionalInfo(additionalInfoArray);
    setUploadedImages({});
  }

  console.log(leadAdditionalDetails?.additionalInfo)

  return (
    <div className={styles.additionalInfoTabWrap}>
      <div className={styles.additionalInfoHeader}>
        <div className={styles.additionalInfoTitle}>Additional Details</div>
        <button
          className={styles.editAdditionalInfoBtn}
          onClick={() => {
            setEditTrue(true);
          }}
          hidden={editTrue}
        >
          <img className={styles.editAdditionalInfoBtnIcon} src={editIcon} alt="edit" />
        </button>
      </div>
      <div className={styles.additionalInfoTableWrap}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <CustomTableHeaderCell style={{width: '40%'}}>Fields</CustomTableHeaderCell>
                <CustomTableHeaderCell>Response</CustomTableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {editedAdditionalInfo
                ?.filter((item: any) => {
                  if (item.fieldType === "file") return false;
                  if (
                    editTrue &&
                    (item.fieldType === "image" || item.fieldType === "profilePic")
                  ) {
                    return true;
                  }
                  if (item.fieldValue === null || item.fieldValue === undefined || item.fieldValue === "") return false;
                  if (Array.isArray(item.fieldValue) && item.fieldValue.length === 0) return false;
                  if (
                    item.fieldType === "phone" &&
                    (item.fieldValue === item.countryCode || item.fieldValue === "")
                  ) return false;
                  return true;
                })
                ?.map((item: any, idx: number) => (
                  <TableRow key={idx}>
                    <CustomTableCell
                      sx={{ textTransform: "capitalize", fontWeight: "500" }}
                    >
                      {item?.fieldLabel}
                    </CustomTableCell>
                    <CustomTableCell>
                      {item.fieldType === "date" ? (
                        editTrue ? (
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                              sx={{
                                zIndex: "99999999 !important",
                                width: "50%",
                                fontSize: "14px",
                                "& .MuiOutlinedInput-input": {
                                  fontSize: "14px",
                                  color: "#142C44",
                                  padding: "9px",
                                },
                              }}
                              format="DD/MM/YYYY"
                              value={item.fieldValue ? dayjs(item.fieldValue) : null}
                              onChange={(newValue: any) => {
                                const updatedDate = editedAdditionalInfo.map((info) =>
                                  info.fieldLabel === item.fieldLabel ? {
                                    ...info,
                                    fieldValue: newValue?.format("DD/MM/YYYY")
                                  } : info
                                );
                                setEditedAdditionalInfo(updatedDate);
                              }}
                            />
                          </LocalizationProvider>
                        ) : (
                          <div>
                            {
                              (dayjs(item.fieldValue).format("DD/MM/YYYY")) === "Invalid Date" ? (item.fieldValue) : dayjs(item.fieldValue).format("DD/MM/YYYY")
                            }
                          </div>
                        )
                      ) : item.fieldType === "checkbox" ? (
                        <div>
                          {editTrue ? (
                            <div style={{flexDirection: 'column', display: 'flex', gap: '5px', alignItems: 'flex-start'}}>
                              {
                                item?.options?.map((option: any) => {
                                  return (
                                    <div 
                                      key={option.id}
                                      style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                                    >
                                      <Checkbox
                                        sx={{
                                          strokeWidth: 1,
                                          color: "#D0D5DD",
                                        }}
                                        id={option.id} 
                                        value={option.id}
                                        defaultChecked={item.fieldValue?.includes(option.id)}
                                        onChange={(e) => handleChange(e, item.fieldLabel)}
                                      />
                                      <label className={styles.checkboxLabel}>{option?.name}</label>
                                    </div>
                                  )
                                })
                              }

                            </div>
                        ) : (
                          Array.isArray(item.fieldValue) ? (
                            <ul className={styles.checkboxList}>
                              {item.fieldValue.map(
                                (value: any, index: number) => (
                                  <li key={index}>{formatValue(value)}</li>
                                )
                              )}
                            </ul>
                          ) : (
                            <ul className={styles.checkboxList}>
                              <li>{capitalizeFirstLetter(item.fieldValue)}</li>
                            </ul>
                          )
                        )}
                        </div>
                      ) : item.fieldType === "phone" ? (
                            editTrue ? (
                              <CountryCodePhoneInput
                                value={item.fieldValue}
                                // onChange={(e: any) => handleChange(e, item.fieldLabel)}
                                disabled={!editTrue}
                                onChange={(event: any, country: any) => {
                                  if (!phone.startsWith(country.dialCode)) {
                                    setPhone(country.dialCode);
                                  } else {
                                    setPhone(event);
                                  }
                                  setContactCountryCode(country.dialCode);
                                  if (event === country.dialCode || event === "") {
                                    setValidStateContact(true);
                                  } else {
                                    setValidStateContact(
                                      isValidPhoneNumber(
                                        `+${country.dialCode}${event.replace(
                                          country.dialCode,
                                          ""
                                        )}`,
                                        country.countryCode.toUpperCase()
                                      )
                                    );
                                  }
                                  const updatedInfo = editedAdditionalInfo.map((info: any) => {
                                    if (info.fieldLabel === item.fieldLabel) {
                                      return {
                                        ...info,
                                        fieldValue: event,
                                        countryCode: country.dialCode,
                                      };
                                    }
                                    return info;
                                  });

                                  setEditedAdditionalInfo(updatedInfo);
                                }}
                                error={validStateContact}
                              />
                            ) : (
                              <div>
                                  {item.fieldValue
                                  ? `+${item.countryCode || "91"} ${
                                      item.countryCode
                                        ? item.fieldValue?.replace(
                                            item.countryCode,
                                            ""
                                          )
                                        : item.fieldValue?.startsWith("91")
                                        ? item.fieldValue?.replace("91", "")
                                        : item.fieldValue
                                    }`
                                  : null}
                              </div>
                            )
                      ) : item?.fieldType === "image" ? (
                        <div>
                          {editTrue ? (
                            <div>
                              <div style={{display: 'flex', flexDirection: 'row', gap: '25px'}}>
                                <FieldFileDropZone
                                  existingImg = {item.fieldValue}
                                  style={{ width: "80%" }}
                                  field={item}
                                  crop={false}
                                  resetTrigger={resetImageTrigger[item.fieldLabel]}
                                  onFieldChange={(_: any, location: string) =>
                                    handleImageUpload(item.fieldLabel, location)
                                  }
                                />
                                {(uploadedImages[item.fieldLabel] || item.fieldValue) && (
                                  <DeleteBtn onClick={() => handledeleteimage(item.fieldLabel)} />
                                )}
                              </div>
                            </div>
                          ) : (
                            <div>
                              <ViewImagePopup
                                style={{paddingLeft: '10px'}}
                                image={item.fieldValue}
                                type={item?.fieldType}
                              />
                            </div>
                          )}
                        </div>
                      ) : item?.fieldType === "profilePic" ? (
                        <div>
                          {editTrue ? (
                            // <input type="file" accept="image" className={styles.imageInput} id="imageUpload"/>
                            <div>
                              <div style={{display: 'flex', flexDirection: 'row', gap: '25px'}}>
                                <FieldFileDropZone
                                  existingImg = {item.fieldValue}
                                  style={{ width: "80%" }}
                                  field={item}
                                  crop={false}
                                  resetTrigger={resetImageTrigger[item.fieldLabel]}
                                  onFieldChange={(_: any, location: string) =>
                                    handleImageUpload(item.fieldLabel, location)
                                  }
                                />
                                {(uploadedImages[item.fieldLabel] || item.fieldValue) && (
                                  <DeleteBtn onClick={() => handledeleteimage(item.fieldLabel)} />
                                )}
                              </div>
                            </div>
                          ) : (
                            <div>
                              <ViewImagePopup
                                style={{paddingLeft: '10px'}}
                                image={item.fieldValue}
                                type={item?.fieldType}
                              />
                            </div>
                          )}
                        </div>
                      ) : item?.fieldType === "text" ? (
                        <div>
                          <input 
                            className={editTrue ? styles.textInputTrue : styles.textInputFalse} 
                            type="text" 
                            disabled={!editTrue} 
                            value={capitalizeFirstLetter(item?.fieldValue)}
                            onChange={(e) => handleChange(e, item.fieldLabel)}
                            style={{
                              fontSize: "14px",
                              color: "#142C44"
                            }}
                          />
                        </div>
                      ) : item?.fieldType === "radio" ? (
                        editTrue ? (
                          <div style={{gap: '10px', display: 'flex'}}>
                            <RadioGroup
                              value={item.fieldValue}
                              onChange={(e) => handleChange(e, item.fieldLabel)}
                            >
                              {item?.options?.map((option: any ) => (
                                <FormControlLabel
                                  key={option.id}
                                  value={option.id}
                                  control={<Radio className={styles.additionalInfoRadioBtn} />}
                                  label={option.name}
                                  sx={{
                                    textTransform: 'capitalize'
                                  }}
                                />
                              ))}
                            </RadioGroup>
                          </div>
                        ) : (
                          <div>{capitalizeFirstLetter(item.fieldValue)}</div>
                        )
                      ) : item?.fieldType === "select" ? (
                        editTrue ? (
                          <div>
                            <Select
                              className={styles.additionalInfoDropdown}
                              disabled={!editTrue}
                              value={item.fieldValue || ""}
                              onChange={(e) => handleChange(e, item.fieldLabel)}
                            >
                              {item?.options?.map((option: any) => (
                                <MenuItem
                                  key={option.id}
                                  value={option.id}
                                  sx={{
                                    color: "#667085",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {option.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                        ) : (
                          <div>
                          {capitalizeFirstLetter(item?.fieldValue)}
                          </div>
                        )
                      ) : (
                        <div>
                          {capitalizeFirstLetter(item?.fieldValue)}
                        </div>
                      )}
                    </CustomTableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {editTrue ? (
          <div className={styles.additionalInfoEditBtnWrap}>
            <CancelBtn 
              onClick={handleCancel}
              title="Cancel"
              disabled={updateLeadAdditionalDetailsLoading}
            />
            <SaveBtn 
              onClick={handleSave}
              title="Save"
              loader={updateLeadAdditionalDetailsLoading}
              disabled={updateLeadAdditionalDetailsLoading}
            />
          </div>
        ) : (
          <div></div>
        )}
    </div>
  );
}

export default LeadAdditionalInfoTab;
